<template>
    <div class="event-view" v-if="eventDetails" style="padding-left: 20px; padding-right: 20px;">
        <!-- Header Section -->
        <div class="header-section">
            <div class="left-icon">
                <i class="fa-solid fa-arrow-left icon" @click="back"></i>
            </div>
            <div class="right-icon">
                <!-- <HeartIcon :isTapped="eventDetails.isLiked ?? false" @toggle="authUser(item, $event)" @click.stop -->
                <!-- class="icon" /> -->
                <!-- <i class="fa-solid fa-share icon" @click.stop="showShareEventModal"></i> -->
            </div>
            <img class="header-image" :src="eventDetails.imageUrls[0]" alt="Event Image" />
            <div class="event-details">
                <h1 class="event-title">{{ eventDetails.title }}</h1>
                <div class="event-info">
                    <p>
                        <i class="fas fa-house icon"></i>
                        <span class="icon-text">{{ eventDetails.venue.name }}</span>
                    </p>
                    <p>
                        <i class="fas fa-map-marker-alt icon"></i>
                        <span class="icon-text">{{ eventDetails.address.street }}, {{ eventDetails.address.city }}, {{
                            eventDetails.address.postalCode }}</span>
                    </p>
                    <p>
                        <i class="fas fa-calendar-alt icon"></i>
                        <span class="icon-text">
                            {{ formatDate(eventDetails.startDate) }} {{ formatTime(eventDetails.startTime) }}
                        </span>
                    </p>
                    <p>
                        <i class="fas fa-tag icon"></i>
                        <span class="icon-text">
                            {{ eventDetails.averagePrice === "0 Kr" ? '- - -' : eventDetails.averagePrice }}
                        </span>
                    </p>
                </div>
                <div class="buttons">
                    <a :href="eventDetails.ticketUrl" target="_blank" class="btn-primary">Köp biljett</a>
                </div>
            </div>
        </div>

        <!-- Description Section -->
        <div class="description-section">
            <h2 class="description-text">Beskrivning</h2>
            <div class="description-subtext" v-if="eventDetails.description">
                <p>{{ eventDetails.description }}</p>
            </div>
            <div v-else class="description-subtext read-more">
                <a :href="eventDetails.ticketUrl" target="_blank">Läs mer hos arrangören</a>
            </div>
        </div>

        <DateCarousel v-if="eventDetails.moreDates" :currentEventId="eventDetails.id" :dates="eventDetails.moreDates" />

        <!-- Map Section -->
        <div class="map-section">
            <h2 class="find-map-text">Hitta hit</h2>
            <div class="map-placeholder">
                <GoogleMap api-key="AIzaSyCxTqWIGGqDaWvkca22UhCPZEW_3iYaTVk" style="width: 100%; height: 300px"
                    :center="center" :zoom="15">
                    <Marker :options="{ position: center }" />
                </GoogleMap>

            </div>
            <button @click="openGoogleMaps" class="btn open-google-map">Öppna i Google Maps</button>
        </div>

        <div class="event-nearby">
            <NetflixScoll :options="{ miniCard: false }" :title="'Event i närheten'"
                :apiUrl="`events/similar/${eventDetails.id}?PageSize=10&PageNumber=`"
                :cacheName="`related-events-${eventDetails.id}`"></NetflixScoll>
        </div>
    </div>

    <ShareEventModal :visible="isShareEventModalVisible" @close="hideShareEventModal" />
    <AccountModal :visible="showLoginModal" @accounModal="toggleAccountModal" />
    <CreateAccountModal :visible="showCreateAccountModal" @accounModal="toggleAccountModal" />
    <ForgotPasswordModal v-if="forgotPasswordModal" @close="forgotPasswordModal = false" />

    <div v-if="!eventDetails" class="loading">
        <p>Laddar eventdetaljer...</p>
    </div>
</template>

<script>
import AxiosInstance from "../../api/axios";
import EventDetails from "../events/models/EventDetailsResponse.js";
// import HeartIcon from "../../components/HeartIcon.vue";
import DateCarousel from "@/components/DateCarousel.vue";
// import NetflixMiniScoll from "../../components/NetflixMiniScoll.vue";
import NetflixScoll from "../../components/NetflixScollDetails.vue";
import AccountModal from "../../components/AccountModal.vue";
import ForgotPasswordModal from "../../components/ForgotPasswordModal.vue";
import CreateAccountModal from "../../components/CreateAccountModal.vue";
import ShareEventModal from "../../components/ShareEventModal.vue";
import { EventBus } from '../../api/EventBusMixin';
// import { GoogleMap, GoogleMarker } from 'vue3-google-map';
import { GoogleMap, Marker } from 'vue3-google-map'

export default {
    name: "EventDetailsView",
    components: { NetflixScoll, ShareEventModal, GoogleMap, Marker, DateCarousel, AccountModal, ForgotPasswordModal, CreateAccountModal },
    props: ['id'],  // The route parameter "id" will be passed as a prop
    data() {
        return {
            center: { lat: 0, lng: 0 },
            eventId: this.id,  // You can use "id" in your component
            eventDetails: null, // This will hold the event details fetched from the API
            showLoginModal: false,
            forgotPasswordModal: false,
            showCreateAccountModal: false,
            isShareEventModalVisible: false,
            markerOptions: {
                // Customize marker options if necessary
                title: "This is a marker",
                icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png", // Optional icon
            },
        };
    },
    async created() {
        try {
            const response = await AxiosInstance.get("events/" + this.eventId);

            // Parse the response using the fromJson method
            this.eventDetails = EventDetails.fromJson(response.data);
            if (this.eventDetails.address.latitude && this.eventDetails.address.longitude) {
                this.center = {
                    lat: parseFloat(this.eventDetails.address.latitude),
                    lng: parseFloat(this.eventDetails.address.longitude),
                };
            }

            this.$gtag.pageview({ page_path: this.eventDetails.title })
        } catch (error) {
            console.error("Failed to fetch event details", error);
        }
    },
    async mounted() {
        EventBus.on('accountModal', this.toggleAccountModal);
        this.initializeMarkerIcon();
    },
    beforeUnmount() {
        EventBus.off('accountModal', this.toggleAccountModal);
    },
    methods: {
        openGoogleMaps() {
            const googleMapsUrl = `https://www.google.com/maps?q=${this.center.lat},${this.center.lng}`;
            window.open(googleMapsUrl, "_blank");
        },
        initializeMarkerIcon() {
            // Check if the google object exists
            /* eslint-disable */
            if (window.google) {
                this.markerOptions.icon = {
                    /* eslint-disable */
                    path: google.maps.SymbolPath.CIRCLE, // Standard circle icon
                    scale: 10, // Icon size
                    fillColor: 'red', // Red color for the fill
                    fillOpacity: 1, // Full opacity
                    strokeColor: 'red', // Red border color
                    strokeWeight: 2, // Border weight
                };
            } else {
                console.error('Google Maps API is not loaded.');
            }
        },
        showShareEventModal() {
            this.isShareEventModalVisible = true;
        },
        hideShareEventModal() {
            this.isShareEventModalVisible = false;
        },
        authUser() {
            if (!this.$isLoggedIn()) {
                EventBus.emit('accountModal', { open: 'login-account' });
                return;
            }
        },
        toggleAccountModal(payload) {
            if (payload.open == "forgot-password") {
                this.forgotPasswordModal = true;
                this.showLoginModal = false;
                this.showCreateAccountModal = false;
            }
            else if (payload.open == "create-account") {
                this.forgotPasswordModal = false;
                this.showLoginModal = false;
                this.showCreateAccountModal = true;
            }
            else if (payload.open == "login-account") {
                this.showLoginModal = true;
                this.forgotPasswordModal = false;
                this.showCreateAccountModal = false;
            }
            else {
                this.forgotPasswordModal = false;
                this.showLoginModal = false;
                this.showCreateAccountModal = false;
            }
        },
        back() {
            this.$router.push('/'); // Navigate back to the main page
        },
        formatDate(dateString) {
            const options = { year: 'numeric', month: 'long', day: 'numeric' };
            return new Date(dateString).toLocaleDateString('sv-SE', options);
        },
        formatTime(timeString) {
            const [hours, minutes] = timeString.split(':');
            return `${hours}:${minutes}`;
        },
    },
};
</script>

<style scoped>
.open-google-map {
    color: white;
    font-size: 12px;
    position: relative;
    left: -10px;
}

.open-google-map:hover {
    color: white;
}

.event-nearby {
    padding-bottom: 100px;
    position: relative;
    left: -8px;
}

/* Responsive Height for Netflix Scroll */
@media (min-width: 900px) {}

@media (max-width: 900px) {}

@media (max-width: 750px) {}

@media (max-width: 600px) {}

@media (max-width: 500px) {}

@media (max-width: 400px) {
    .event-title {
        font-size: 18px !important;
    }

    .icon {
        font-size: 11px !important;
    }

    .icon-text {
        font-size: 10px !important;
    }

    .fa-house {
        font-size: 10px !important;
    }

    .description-text {
        font-size: 14px !important;
    }

    .find-map-text {
        font-size: 14px !important;
    }

    .btn-primary {
        padding: 4px 8px !important;
        font-size: 14px !important;
    }
}

/* h2 {
    font-size: 15px !important;
} */

.read-more {
    font-size: 12px;
    color: white;
}

.left-icon {
    position: absolute;
    top: 10px;
    left: 10px;
}

.right-icon {
    position: absolute;
    top: 10px;
    right: 10px;
}

.fa-house {
    font-size: 12px;
}

.icon-text {
    margin-left: 5px;
}

.right-icon .icon {
    margin-right: 10px;
}

.left-icon .icon,
.right-icon .icon {
    display: inline-block;
    /* Ensures icon is treated as a block */
    width: 20px;
    /* Set the width of the circle */
    height: 20px;
    /* Set the height of the circle */
    border-radius: 50%;
    /* Makes the icon circular */
    background-color: #f0f0f0;
    /* Optional: background color of the circle */
    text-align: center;
    /* Centers the icon horizontally */
    line-height: 21px;
    /* Centers the icon vertically */
    font-size: 12px;
    /* Adjusts the icon size */
    color: #333;
    /* Icon color */
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    /* Optional: shadow for better look */
    cursor: pointer;
}

.event-info p,
.event-info div {
    color: white !important;
}

.icon {
    color: rgba(255, 255, 255, 0.8);
}

.event-view {
    padding-top: 10px;
    color: #333;
    max-width: 800px;
    margin: auto;
}

/* Header Section */
.header-section {
    position: relative;
}

.header-image {
    width: 100%;
    object-fit: fill;
    border-radius: 10px;
}

.event-details {
    margin-top: 10px;
}

.event-title {
    font-size: 28px;
    font-weight: bold;
}

.event-info p {
    margin: 5px 0;
    font-size: 14px;
    color: #666;
}

.buttons {
    margin-top: 20px;
    display: flex;
    gap: 10px;
}

.btn-primary {
    background-color: white;
    /* #1c6114; */
    color: black;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    text-decoration: none;
}

.btn-secondary {
    background-color: white;
    color: #333;
    padding: 10px 20px;
    border: 1px solid #ccc;
    border-radius: 5px;
    cursor: pointer;
}

/* Description Section */
.description-section {
    margin-top: 40px;
}

.description-section h2,
.map-section h2 {
    font-size: 20px;
    margin-bottom: 5px;
    color: white;
}

/* Map Section */
.map-section {
    margin-top: 60px;
}

.map-placeholder {
    width: 100%;
    height: 300px;
    background-color: #eee;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
}

.btn-map {
    background-color: #007bff;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.loading {
    font-size: 20px;
    color: #999;
    text-align: center;
    padding: 50px;
}
</style>